export default {
	'planned-visit': 'زيارة مخططة',
}
